<template>
  <v-card
      elevation="0"
      flat
      tile
      class="pl-3 pt-3 pb-md-3"
  >
    <h2 class="primary--text font-weight-bold pt-5 pl-2">
      {{ $t('components:common.additional-elevators') }}
    </h2>
    <ul class="select-list">
      <li v-on:click="selectAll">
        <u>{{ $t('buttons:select-all') }}</u>
      </li>
      <li v-on:click="deSelectAll">
        <u>{{ $t('buttons:deselect-all') }}</u>
      </li>
    </ul>

    <template>
      <v-treeview
          selectable
          :items="checkboxElevators"
          item-text="name"
          item-value="id"
          v-model="selected"
      ></v-treeview>
    </template>

  </v-card>
</template>

<script>

import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: "AdditionalElevator",
  props: {
    isAdmin: Boolean
  },
  data() {
    return {
      fullElevators: [],
      checkboxElevators: [],
      selected: []
    }
  },
  methods: {
    selectAll() {
      for (let i = 0; i < this.checkboxElevators.length; i++) {
        this.selected.push(this.checkboxElevators[i].id);
      }
    },
    deSelectAll() {
      this.selected = [];
    },
    elevatorLoaded(excludedElevator) {
      this.reset(); //reset on start of the loading process, so we clear all checkbox entries

      let shouldElevatorExclude = typeof excludedElevator !== 'undefined' && excludedElevator !== null;
      for (let i = 0; i < this.fullElevators.length; i++) {
        if (shouldElevatorExclude && (this.fullElevators[i][0] == excludedElevator.id)) continue;

        this.checkboxElevators.push({
          id: this.fullElevators[i][0],
          name: this.fullElevators[i][1]
        });
      }
    },
    loadElevatorByElevatorCustormer(elevator) {
      this.fullElevators = [];
      ElevatorService.getElevatorsByElevatorCustomer(elevator,
          (response) => {
            this.fullElevators = response.data;
            this.elevatorLoaded(elevator);
          }
      );

    },
    reset() {
      this.deSelectAll();
      this.checkboxElevators = [];
    }
  },
  watch: {
    selected() {
      this.$emit('updateElevators', this.selected);
    }
  },
  created() {
    if (!this.isAdmin) {
      ElevatorService.getElevatorsByCustomer(
          (response) => {
            this.fullElevators = response.data;
            this.$emit('elevatorIsLoaded');
          }
      );
    }
  }
}
</script>

<style scoped>
.select-list {
  text-transform: uppercase;
  cursor: pointer;
  list-style-type: none;
}
</style>
